import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { unFormatUnknownUnit } from '@/common/utils/unFormatters'
import { EstablishmentRequiredDocumentValidationSchema } from '@/features/maintenance/establishmentRequiredDocuments/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateEstablishmentRequiredDocumentProps {
  id: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useUpdateEstablishmentRequiredDocument = ({
  id,
  onSuccess,
  onError,
}: UseUpdateEstablishmentRequiredDocumentProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentRequiredDocument'],
    mutationFn: async ({ form }: { form: EstablishmentRequiredDocumentValidationSchema }) => {
      const required_document = {
        display_name: form.display_name,
        default_validity_in_days:
          form.has_default_validity_in_days && form.default_validity_in_days
            ? unFormatUnknownUnit(form.default_validity_in_days)
            : '',
        file_sample: typeof form.file_sample === 'string' ? undefined : form.file_sample,
      }

      return privateAxios.putForm(`/maintenance/establishment_required_documents/${id}`, { required_document })
    },
    onSuccess,
    onError,
  })
}
